var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("animated-number", {
    attrs: {
      value: _vm.value,
      formatValue: _vm.formatValue,
      duration: _vm.animationDuration,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }